/* eslint-disable jira/filename-case */
export const ATLASSIAN_ACCOUNT = 'ATLASSIAN_ACCOUNT';
export const SITE = 'SITE';
export const SITE_USER = 'SITE_USER';
export const ORG = 'ORG';
export const ORG_USER = 'ORG_USER';

export const TRAIT_ENDPOINT_STARTING_FRAGMENT = '/gateway/api/tap-delivery/api/v3/personalization/';

export const TraitsEntities: readonly [
	'ATLASSIAN_ACCOUNT',
	'SITE',
	'SITE_USER',
	'ORG',
	'ORG_USER',
] = [ATLASSIAN_ACCOUNT, SITE, SITE_USER, ORG, ORG_USER] as const;
